import { Modal } from "@mui/material";
import {
    ReactElement,
    HTMLAttributes
} from "react";
type ModalSize = "sm" | "md" | "lg" | "xl" | "auto";

interface Props extends HTMLAttributes<HTMLElement> {
    openModal: boolean;
    children: ReactElement,
    onClose?: any;
    myStyle?:string;
      size?: ModalSize;
}

export function CustomModal({ openModal, onClose, children , myStyle , size = "md",}: Props): ReactElement {
    return (
        <Modal
            open={openModal}
            onClose={onClose}
            aria-labelledby="custom-modal-title"
            aria-describedby="custom-modal-description"
        >
             <div className={`${myStyle && myStyle } custom-modal custom-modal--${size}`}>
            {children}</div>
        </Modal>
    );
}

export default CustomModal;